export const todoFormate = {
  id: 1,
  title: "",
  listId: null,
  myDay: false,
  isImportant: false,
  isBookmark: false,
  isComplete: false,
  dueDate: "",
  files: [],
  notes: "",
  steps: [],
  createdAt: null
};

export const listFormat = {
  id: "",
  title: "",
  count: 0
};

export const stepFormat = {
  id: "",
  title: "",
  isComplete: false
};
